/**
 * As abas que o administrador libera para cada MEMBRO (Administrativo › Usuários).
 *
 * A chave é a rota da aba no menu, a mesma do catálogo da API
 * (`liv-api/src/common/access/portal-tabs.ts`). Administrador vê tudo; Visão Geral e Meu
 * Usuário são de todos; Usuários, Equipes e Chaves de API são só de administrador.
 *
 * Aba nova: acrescente aqui e no catálogo da API, ponha o item no menu
 * (navigation.service.ts) e a trava na rota (`tabGuard(TAB.NOVA)` em app.routes.ts).
 * Ver AGENTS.md › Permissões por aba.
 */
export const TAB = {
  TASKS: '/tasks',
  APPOINTMENTS: '/appointments',
  COMMERCIAL: '/commercial',
  CONTACTS: '/contacts',
  AVAILABILITY: '/availability',
  CONTRACTS: '/contracts',
  ATTENDANCE: '/attendance',
  RESERVATIONS: '/reservations',
  MAINTENANCE: '/attendance/maintenance',
  WATER_METER: '/water-meter',
  INSPECTIONS: '/inspections',
  ANNOUNCEMENTS: '/announcements',
  OCCUPANCY_MAP: '/occupancy-map',
  FINANCIAL_ENTRIES: '/financial-entries',
  BUILDING_NOTES: '/building-notes',
  RESIDENTS: '/residents',
  APARTMENTS: '/apartments',
  COMMUNITY: '/community',
  SITE: '/site',
  GALLERY: '/gallery',
  VACATIONS: '/vacations',
} as const;

export type TabKey = (typeof TAB)[keyof typeof TAB];

export const TAB_KEYS: readonly TabKey[] = Object.values(TAB);

/** Quem edita unidades, modelos e os itens do site ligados a eles. */
export const UNIT_EDITOR_TABS: readonly TabKey[] = [TAB.APARTMENTS, TAB.SITE];

/** Quem abre a página de uma oportunidade: o Funil e as telas comerciais (igual à API). */
export const OPPORTUNITY_TABS: readonly TabKey[] = [TAB.COMMERCIAL, TAB.CONTACTS, TAB.AVAILABILITY];

/**
 * O que cada cargo antigo enxergava no menu. Os usuários desses cargos viraram MEMBRO com
 * exatamente estas abas (mesma tabela da API, `LEGACY_ROLE_TABS`). Se a API ainda devolver
 * um cargo antigo (publicação fora de ordem, cache), o portal o trata como esse membro.
 */
export const LEGACY_ROLE_TABS: Record<'AGENT' | 'SERVICE_MANAGER' | 'EDITOR', readonly TabKey[]> = {
  AGENT: [
    TAB.TASKS,
    TAB.APPOINTMENTS,
    TAB.COMMERCIAL,
    TAB.CONTACTS,
    TAB.AVAILABILITY,
    TAB.CONTRACTS,
    TAB.VACATIONS,
  ],
  SERVICE_MANAGER: [
    TAB.TASKS,
    TAB.APPOINTMENTS,
    TAB.ATTENDANCE,
    TAB.RESERVATIONS,
    TAB.MAINTENANCE,
    TAB.WATER_METER,
    TAB.INSPECTIONS,
    TAB.ANNOUNCEMENTS,
    TAB.OCCUPANCY_MAP,
    TAB.FINANCIAL_ENTRIES,
    TAB.BUILDING_NOTES,
    TAB.RESIDENTS,
    TAB.APARTMENTS,
    TAB.COMMUNITY,
    TAB.VACATIONS,
  ],
  EDITOR: [TAB.SITE, TAB.GALLERY, TAB.VACATIONS],
};

/** Uma aba do catálogo da API: o que aparece como caixa no cadastro de usuário. */
export interface PortalTab {
  key: string;
  label: string;
  group: string;
}
